<script setup lang="ts">
import {
  toRef,
} from 'vue';

import VFormFloatLabelInputWrapper
  from '@modules/forms/components/inputs/VFormFloatLabelInputWrapper/VFormFloatLabelInputWrapper.vue';
import VFormInputWrapper
  from '@modules/forms/components/inputs/VFormInputWrapper/VFormInputWrapper.vue';

import type {
  VFormPasswordInputEmits,
  VFormPasswordInputProps,
} from './types';
import { useInputInnerValue } from '../composables';

const props = withDefaults(defineProps<VFormPasswordInputProps>(), {});
const emit = defineEmits<VFormPasswordInputEmits>();
const { innerValue } = useInputInnerValue(toRef(props, 'value'));
</script>

<template>
  <VFormInputWrapper v-data-qa-auto-id="'VFormPasswordInput'"
    v-data-test="{ el: 'password-input', name }"
    :errors="errors"
    :hide-errors="hideErrors"
    :readonly="readonly"
    :class="isFullWidth ? 'w-full' : 'input-max-width'"
  >
    <VFormFloatLabelInputWrapper
      :name="name"
      :label="label"
      :icon-left="iconLeft"
      :icon-right="iconRight"
      :required="required"
      :readonly="readonly"
    >
      <PInputPassword
        v-model="innerValue"
        :name="name"
        :placeholder="placeholder"
        type="password"
        toggle-mask
        :input-id="name"
        :required="required"
        :readonly="readonly"
        :disabled="disabled"
        :feedback="false"
        class="w-full"
        :class="{ 'p-invalid': isInvalid && !readonly }"
        :pt="{
          pcInputText: {
            root: {
              class: 'w-full',
              autocomplete,
            },
          },
        }"
        @blur="emit('blur', innerValue)"
        @focus="emit('focus', innerValue)"
        @change="emit('change', innerValue)"
        @input="emit('input', innerValue)"
      />
    </VFormFloatLabelInputWrapper>
  </VFormInputWrapper>
</template>
